<script>
  import dayjs from 'dayjs'
  import tz from 'dayjs/plugin/timezone'
  import utc from 'dayjs/plugin/utc'
  import adv from 'dayjs/plugin/advancedFormat'

  dayjs.extend(tz)
  dayjs.extend(utc)
  dayjs.extend(adv)

  export let type
  export let series
  export let chart
  export let shortLegend

  // We do this because the object.visible setting is opposite
  // of intended state of "hide". Set initial state on load.
  let hide = type.visible == true ? false : true

  let tt = ''
  let bt = ''
  try {
    // Get either the stageflows or nwm created times for legend tooltips.
    if (type.name == 'Observed') {
      tt = series.observedIssuedTime
      type.visible = false
      hide = true
      type.hide()
    } else if (type.name == 'Forecast') {
      type.visible = false
      hide = true
      type.hide()
      tt = series.forecastIssuedTime
    } else if (series.nwm && type.userOptions.id in series.nwm && 'referenceTime' in series.nwm[type.userOptions.id]) {
      tt = series.nwm[type.userOptions.id].referenceTime
    }

    if (tt) {
      let d = dayjs(tt).tz(series.timeZone)
      tt = 'reference time: ' + d.format('ddd MMM D, YYYY h:mm:ss A z')
      bt = d.format('MM/DD/YYYY h:mm A z')
    }
  } catch (e) {
    console.log(e)
  }

  function handleLowWater(chartSeries) {
    let idx = chartSeries.yAxis.plotLinesAndBands.findIndex((i) => i.id === 'line_lowwater')
    if (idx < 0) {
      chartSeries.yAxis.addPlotLine(series['lowwater_stageline'])
      chartSeries.yAxis.update({ plotbands: series.plotBands })
      hide = false
    } else {
      chartSeries.yAxis.removePlotLine('line_lowwater')
      chartSeries.yAxis.removePlotBand('line_lowwater')
      // Hide (remove) the lowwater shaded band OWP-824
      let v = chartSeries.yAxis.plotLinesAndBands
      let i = chartSeries.yAxis.plotLinesAndBands.length
      while (i--) {
        if (v[i].id === 'lowwaterShading') {
          chartSeries.yAxis.plotLinesAndBands[i].destroy()
        }
      }
      hide = true
    }
  }

  function handleLineRecord(chartSeries) {
    let idx = chartSeries.yAxis.plotLinesAndBands.findIndex((i) => i.id === 'line_record')
    if (idx < 0) {
      chartSeries.yAxis.addPlotLine(series['record_stageline'])
      hide = false
    } else {
      chartSeries.yAxis.removePlotLine('line_record')
      hide = true
    }
  }

  function handlePlotBands(chartSeries) {
    if (chartSeries.visible) {
      let v = chartSeries.yAxis.plotLinesAndBands
      let i = chartSeries.yAxis.plotLinesAndBands.length
      while (i--) {
        if (v[i].options.class == 'plotbands') {
          chartSeries.yAxis.plotLinesAndBands[i].destroy()
        }
      }
      chartSeries.visible = false
      hide = true
    } else {
      chartSeries.yAxis.update({ plotands: series.plotBands })
      chartSeries.visible = true
      hide = false
    }
  }

  function handleNormalPool(chartSeries) {
    let idx = chartSeries.yAxis.plotLinesAndBands.findIndex((i) => i.id === 'normal_pool')
    if (idx < 0) {
      chartSeries.yAxis.addPlotLine(series['normal_pool'])
      hide = false
    } else {
      chartSeries.yAxis.removePlotLine('normal_pool')
      hide = true
    }
  }

  function handleClick(chartSeries, chart, series) {
    switch (chartSeries.userOptions.id) {
      case 'normal_pool':
        handleNormalPool(chartSeries)
        break
      case 'line_record':
        handleLineRecord(chartSeries)
        break
      case 'line_lowwater':
        handleLowWater(chartSeries)
        break
      case 'plotlinebands':
        handlePlotBands(chartSeries)
        break
      default:
        if (chartSeries.visible) {
          chartSeries.hide()
          hide = true
        } else {
          chartSeries.show()
          hide = false
        }
        break
    }
  }
</script>

{#if /Pool|Low|Flood|Record/.test(type.name)}
  <div
    class:hide
    on:click={() => handleClick(type, chart, series)}
    on:keypress={() => handleClick(type, chart, series)}
  >
    <div class="symbol" style="background-color: {type.color}" />
    <div class="seriesname">{type.name}</div>
  </div>
{:else}
  <div
    class:hide
    on:click={() => handleClick(type, chart, series)}
    on:keypress={() => handleClick(type, chart, series)}
    uk-tooltip="title: {type.name} {tt || 'N/A'} ; pos: top-left"
  >
    <div class="symbol" style="background-color: {type.color}" />
    <div class="seriesname">
      {type.name === 'Forecast' ? `Official ${type.name}` : `${type.name}`} ({shortLegend[type.name]}) <span>{bt}</span>
    </div>
  </div>
{/if}

<style>
  .symbol {
    width: 20px;
    height: 20px;
    margin-right: 20px;
    float: left;
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  .seriesname {
    cursor: pointer;
  }

  .hide {
    opacity: 0.2;
  }

  li {
    list-style: none;
  }
  span {
    font-size: 10pt;
  }
</style>
